import { Filter } from "bad-words";

export const filter = new Filter();

export const MAX_DESCRIPTION_LENGTH = 250;

export const PUBLIC_STATUSES = [
  "approved",
  "pendingEdit",
  "pendingDelete",
  "pendingReport",
];

export const REPORT_REASONS = [
  { value: "spam", label: "Spam" },
  { value: "inappropriate", label: "Inappropriate content" },
  { value: "fake", label: "Fake review" },
  { value: "other", label: "Other" },
];

export const SORT_OPTIONS = [
  { value: "newest", label: "Newest" },
  { value: "oldest", label: "Oldest" },
  { value: "ratingHigh", label: "Rating: High to Low" },
  { value: "ratingLow", label: "Rating: Low to High" },
  { value: "mostLiked", label: "Most Liked" },
];